import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent24: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Develop product plan</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Develop product plan
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step, you will revisit your follow-on market TAM and develop a product plan so that your product is not just an island that leads nowhere. You will go beyond the Minimum Viable Business Product (MVBP) to determine which features you will build out for the beachhead market, then you will determine which adjacent markets you will sell to after dominating the beachhead market, and how your product will have to change for each new market.

The Product Plan you will develop in this step builds on the work you have done in the TAM for follow-on markets. When you established your MVBP, you most likely took a number of features and put them on hold to concentrate on the bare minimum feature set required. In the Product Plan, you will select which of these features, based on your Persona’s needs, to incorporate back into the product. There may be features that you thought the Persona would want up front; but as you further developed your ideas of the product and customer, you find they are much less important than other features you did not consider at first. It is important to institute a protocol within the development of your product where you continuously ensure a high level of quality through process and mindset. When new features or functionality are released, even with the best of intentions, it usually takes a while in the marketplace to work the bugs out and refine the product.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Develop the product plan
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  Establishing a product plan is similar to the step to calculate the broader TAM. The idea is to get you thinking ahead so you raise your sightlines and don’t get too bogged down in your beachhead market, which is only your first step as a business.

Review and better define your beachhead market. You want to expand from the beachhead. It gives you a long-term vision that keeps you reaching and thinking ahead, especially in the design of your product and organization.
Decide follow-on markets. Use the “bowling alley” metaphor from step 14, and take into consideration any new information that you’ve discovered and analyzed during this journey.
Decide how the product will evolve/change to respond to these new markets. Customers in new markets will need new features or ways to use the product—and these should be dictated by your market growth approach, not only by internal technical considerations or constraints.
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent24 };
